export default __webpack_public_path__ + "static/media/avatar_nv_1.86a3f62a.jpg";